const phoneAction = (state = "", action) => {
    switch(action.type) {
        case 'phoneAction':
            return action.payload;
        default:
            return state;
    }
}

export default phoneAction;